import { useState, useEffect } from 'react';

/**
 * 判断当前屏幕宽度是否小于1024px的Hook
 * @param breakpoint - 断点宽度，默认1024px
 * @returns {boolean} - 是否为移动设备（屏幕宽度小于断点）
 */
const useIsMobile = (breakpoint = 1024) => {
  // 初始化状态，判断当前屏幕宽度是否小于断点
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    // 处理窗口大小变化的函数
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // 添加窗口大小变化事件监听
    window.addEventListener('resize', handleResize);

    // 组件卸载时移除事件监听
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]); // 当断点变化时重新设置监听

  return isMobile;
};

export default useIsMobile;
